export const GET_PIPELINES = "GET_PIPELINES";
export const GET_PIPELINE_BY_ID = "GET_PIPELINE_BY_ID";
export const UPDATE_PIPELINE = "UPDATE_PIPELINE";
export const DELETE_PIPELINE = "DELETE_PIPELINE";
export const CREATE_PIPELINE = "CREATE_PIPELINE";
export const GET_PIPELINE_GRAPH_BY_ID = "GET_PIPELINE_GRAPH_BY_ID";
